// File containing all the base configs used in the map
export const MAP_CONSTANTS = {
    defaultZoom: 10,
    defaultCenter: [233330, 145000],
    minZoom: 3,
    maxZoom: 15,
    zoomFactor: 2,
}